var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiUploadCloudFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 41.9615C11.2681 41.7518 8.67231 40.6842 6.5833 38.9113C4.49429 37.1383 3.01887 34.7507 2.3677 32.0892C1.71654 29.4278 1.92293 26.6286 2.9574 24.0915C3.99188 21.5543 5.80154 19.4089 8.12799 17.9615C8.62301 14.1017 10.5076 10.5545 13.429 7.98384C16.3505 5.41315 20.1086 3.99512 24 3.99512C27.8914 3.99512 31.6495 5.41315 34.571 7.98384C37.4924 10.5545 39.377 14.1017 39.872 17.9615C42.1984 19.4089 44.0081 21.5543 45.0426 24.0915C46.077 26.6286 46.2834 29.4278 45.6323 32.0892C44.9811 34.7507 43.5057 37.1383 41.4167 38.9113C39.3277 40.6842 36.7319 41.7518 34 41.9615V41.9995H14V41.9615ZM26 25.9995H32L24 15.9995L16 25.9995H22V33.9995H26V25.9995Z",
    fill: "#82B8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiUploadCloudFill);
export default __webpack_public_path__ + "static/media/ri_upload-cloud-fill.2716de5b17448c5485552494b6d5f7d2.svg";
export { ForwardRef as ReactComponent };